var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"mc-pagehead"},[_c('div',[_c('h1',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('p',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"mc-actions"},[(_vm.updated)?_c('span',{class:['mc-updated', { 'is-stale': _vm.stale }]},[_vm._v("Aggiornato "+_vm._s(_vm.updated))]):_vm._e(),_vm._t("actions")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }